import { Link } from "react-router-dom";
import { strengthsLabel, priceLabel } from "../lib/product";
import { ProductImage, primaryImageId } from "./ProductImage";

export const ProductCard = ({ product: p, skincare = false }) => (
  <Link
    to={skincare ? `/skincare/${p.id}` : `/product/${p.id}`}
    data-testid={`catalog-card-${p.id}`}
    className="bg-white rounded-2xl border border-[#D8CDBC] overflow-hidden hover:shadow-md hover:-translate-y-0.5 transition-transform transition-shadow duration-300 group"
  >
    <ProductImage imageId={primaryImageId(p)} alt={p.name} iconSize={64} />
    <div className="p-5">
      <h3 className="font-serif text-xl leading-tight group-hover:text-[#59394F] transition-colors">{p.name}</h3>
      <p className="text-xs text-[#5E4D5A] mt-1">{strengthsLabel(p)}{!skincare && p.form ? ` · ${p.form}` : ""}</p>
      <div className="mt-4 flex items-end justify-between">
        <p className="text-base font-medium">{priceLabel(p)}</p>
        {!skincare && <p className="text-[10px] uppercase tracking-[0.2em] text-[#5E6B51]">RUO</p>}
      </div>
    </div>
  </Link>
);
